import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _appReviewsSummary = { averageRating: 'DOUBLE' };
var _queryAppReviewsSummaryRequest = {};
var _queryAppReviewsSummaryResponse = {
    appReviewsSummaries: '_appReviewsSummary',
};
function resolveWixDevcenterAppsummariesV1AppReviewsSummaryServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/app-summaries',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/app-summaries',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/app-summaries',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/app-summaries',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/app-summaries',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/app-summaries',
                destPath: '',
            },
            {
                srcPath: '/app-summaries',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Query AppReviewsSummaries using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
export function queryAppReviewsSummary(payload) {
    var _a = serializer(_queryAppReviewsSummaryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryAppReviewsSummaryResponse, {
        _appReviewsSummary: _appReviewsSummary,
    }).fromJSON;
    function __queryAppReviewsSummary(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.appreviewssummaries.v1.app_reviews_summary',
            method: 'POST',
            methodFqn: 'wix.devcenter.appsummaries.v1.AppReviewsSummaryService.QueryAppReviewsSummary',
            url: resolveWixDevcenterAppsummariesV1AppReviewsSummaryServiceUrl({
                protoPath: '/v1/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryAppReviewsSummary.fromReq = fromReq;
    __queryAppReviewsSummary.__isAmbassador = true;
    return __queryAppReviewsSummary;
}
//# sourceMappingURL=http.impl.js.map